import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { Button } from '../../../../../components';
import { GROUP_USER } from '../../../../../config/appGroupConfig';
import { APP_ROUTES } from '../../../../../constants/app-routes';

export default function CheckOutButtons({ eventId, role, onDisableClicked }) {
  const navigate = useNavigate();

  if (![GROUP_USER.VENUE, GROUP_USER.ADMIN].includes(role)) {
    return null;
  }

  return (
    <Grid container spacing={2} alignItems="center" mt={1}>
      <Grid item>
        <Typography variant="h6" marginTop={0}>
          Check out:
        </Typography>
      </Grid>
      {role === GROUP_USER.ADMIN && (
        <Grid item>
          <Button size="small" label="Disable Event" onClick={onDisableClicked} />
        </Grid>
      )}
      {role === GROUP_USER.VENUE && (
        <Grid item>
          <Button
            size="small"
            label="Management"
            onClick={() => navigate(APP_ROUTES.EVENT_MANAGEMENT.replace(':eventId', eventId))}
          />
        </Grid>
      )}
    </Grid>
  );
}

CheckOutButtons.propTypes = {
  eventId: PropTypes.number.isRequired,
  role: PropTypes.string,
  onDisableClicked: PropTypes.func.isRequired,
};

CheckOutButtons.defaultProps = {
  role: '',
};
